import type { FilterOption } from '../types';

const filterDisabledOptions = (option: FilterOption) => {
  return !option.disabled;
};

export default filterDisabledOptions;
